import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { SectionHeader } from "./Features";

export default function FAQ() {
  const { t } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-20 md:py-32">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <SectionHeader eyebrow={t.faq.eyebrow} title={t.faq.title} />

        <div className="mt-12 space-y-3" data-testid="faq-list">
          {t.faq.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                className={`rounded-2xl bg-surface/60 border ${isOpen ? "border-brand-orange/35" : "border-white/[0.07]"} overflow-hidden transition-colors`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left"
                  data-testid={`faq-trigger-${i}`}
                  aria-expanded={isOpen}
                >
                  <span className="text-base md:text-lg font-medium text-white">{item.q}</span>
                  <span className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center flex-shrink-0">
                    {isOpen ? <Minus size={16} className="text-brand-orange" /> : <Plus size={16} className="text-white/70" />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: "easeOut" }}
                      className="overflow-hidden"
                    >
                      <div className="px-6 pb-6 text-sm md:text-[15px] text-white/65 leading-relaxed" data-testid={`faq-content-${i}`}>
                        {item.a}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
